import { ViewMode } from '../constants';
import { get, post, put, remove as httpRemove } from '../Services/http';
import { catchError } from './Error.action';
import { load as loadCart } from './Cart.action';
import {
  PRODUCT_CONFIGURATOR_RECEIVE,
  PRODUCT_CONFIGURATOR_SEND,
  PRODUCT_CONFIGURATOR_UPDATE,
  PRODUCT_CONFIGURATOR_ERROR,
} from '../constants';

const rootRoute = '/api/configurationOptions';

export const getVariantData = (articleNo) => (dispatch) => {
  return get(rootRoute + '/getOptions?articleNo=' + articleNo)
    .then((response) => response.json())
    .then((result) => {
      dispatch(receiveVariantData(result));
    })
    .catch((ex) => dispatch(catchError(ex, (error) => setError(error))));
};

export const updatingSelectedData = (options) => (dispatch) => {
  const sendOptions = getSendObject(options, '');
  return post(rootRoute + '/updateOptions', sendOptions)
    .then((response) => response.json())
    .then((result) => {
      dispatch(responseUpdatingVariantData(result));
    })
    .catch((ex) =>
      dispatch(
        catchError(ex, (error) => {
          setError(error);
        })
      )
    );
};

export const setVariantData = (options, userText) => (dispatch) => {
  const sendOptions = getSendObject(options, userText);
  return post(rootRoute + '/sendOptions', sendOptions)
    .then((response) => response.json())
    .then((result) => {
      dispatch(responseSetVariantData(result));
    })
    .catch((ex) =>
      dispatch(
        catchError(ex, (error) => {
          setError(error);
        })
      )
    );
};

const getSendObject = (options, userText) => {
  const items = [];
  options.items.map((item) => {
    const selectedData = {
      title: item.title,
      selectedData: item.variantData.find((y) => y.selected === true),
    };
    items.push(selectedData);
  });
  return {
    articleNo: options.articleNo,
    items,
    message: userText,
  };
};

const receiveVariantData = (variantData) => ({
  type: PRODUCT_CONFIGURATOR_RECEIVE,
  payload: {
    variantData,
  },
});
export const responseSetVariantData = (response) => (dispatch) => {
  dispatch(loadCart());
  dispatch({
    type: PRODUCT_CONFIGURATOR_SEND,
    payload: {
      returnMessage: response.message,
    },
  });
};

export const responseUpdatingVariantData = (response) => (dispatch) => {
  dispatch({
    type: PRODUCT_CONFIGURATOR_UPDATE,
    payload: {
      configMessage: response.message,
    },
  });
};

export const setError = (error) => ({
  type: PRODUCT_CONFIGURATOR_ERROR,
  payload: {
    error,
  },
});
